import Phaser from 'phaser'
import Config from '../launch/config'
import Particle from './particle'
import audio from '../launch/audio'

// TODO: investigate particle effects
// https://phaser.io/examples/v3/category/game-objects/particle-emitter
// https://github.com/photonstorm/phaser3-examples/tree/master/public/assets/particles
// https://rexrainbow.github.io/phaser3-rex-notes/docs/site/particles/

export default class Effects {
    explode(x, y, faction) {
        const initRadius = 10
        const blastRadius = 120

        for (let i = 0; i < 30; i += 1) {
            const scale = Config.chance.floating({min: 0.08, max: 0.15})
            const particle = new Particle(
                Config.scene,
                Phaser.Math.Between(x - initRadius, x + initRadius),
                Phaser.Math.Between(y - initRadius, y + initRadius),
                scale
            )
            particle[Config.namespace] = {type: 'effects particle'}

            Config.scene.add.existing(particle)

            // const color =
            //     faction === Config.userFactionName
            //         ? Config.colorGreen
            //         : Config.colorRed
            // particle.setTint(`0x${color}`)

            Config.scene.tweens.add({
                targets: particle,
                alpha: {from: 1, to: 0},
                x: Phaser.Math.Between(x - blastRadius, x + blastRadius),
                y: Phaser.Math.Between(y - blastRadius, y + blastRadius),
                ease: 'Linear',
                duration: 1000,
                onComplete: (tween, targets) => {
                    targets[0].destroy()
                },
            })
        }
    }

    pulse({color, delayIncr, duration, radius, x, y}) {
        let delay = 0
        for (let i = 0; i < 3; i += 1) {
            const ringGraphics = Config.scene.add.graphics({
                lineStyle: {width: 3, color: `0x${color || 'ffffff'}`},
            })
            const ringCircle = new Phaser.Geom.Circle(x, y, 0)
            ringGraphics.strokeCircleShape(ringCircle)
            ringGraphics[Config.namespace] = {type: 'pulse ringGraphics'}

            Config.scene.add.existing(ringGraphics)

            Config.scene.tweens.add({
                delay,
                targets: ringCircle,
                radius: radius || 50,
                ease: 'Power1',
                duration: duration || 500,
                onUpdate: (tween, targets) => {
                    ringGraphics.clear()
                    ringGraphics.alpha -= 0.07
                    ringGraphics.strokeCircleShape(ringCircle)
                },
                onComplete: (tween, targets) => {
                    ringGraphics.destroy()
                },
            })
            delay += delayIncr || 100
        }
    }

    ringGrowFade({color, duration, minRadius, maxRadius, width, x, y}) {
        const ringGraphics = Config.scene.add.graphics({
            lineStyle: {width: width || 3, color: color || 0xffffff},
        })
        const ringCircle = new Phaser.Geom.Circle(x, y, minRadius || 0)
        ringGraphics.strokeCircleShape(ringCircle)
        ringGraphics[Config.namespace] = {type: 'circle ringGraphics'}

        Config.scene.add.existing(ringGraphics)

        Config.scene.tweens.add({
            targets: ringCircle,
            radius: maxRadius || 30,
            ease: 'Sine.easeOut',
            duration: duration || 500,
            onUpdate: (tween, targets) => {
                ringGraphics.alpha -= 0.01
                ringGraphics.clear()
                ringGraphics.strokeCircleShape(ringCircle)
            },
            onComplete: (tween, targets) => {
                ringGraphics.destroy()
            },
            // yoyo: true,
        })
    }

    ringSwell({duration, minRadius, maxRadius, width, x, y}) {
        const ringGraphics = Config.scene.add.graphics({
            lineStyle: {width: width || 3, color: 0xffffff},
        })
        const ringCircle = new Phaser.Geom.Circle(x, y, minRadius || 0)
        ringGraphics.strokeCircleShape(ringCircle)
        ringGraphics[Config.namespace] = {type: 'circle ringGraphics'}

        Config.scene.add.existing(ringGraphics)

        Config.scene.tweens.add({
            targets: ringCircle,
            alpha: {from: 1, to: 0},
            radius: maxRadius || 30,
            ease: 'Power1',
            duration: duration || 500,
            onUpdate: (tween, targets) => {
                ringGraphics.clear()
                ringGraphics.strokeCircleShape(ringCircle)
            },
            onComplete: (tween, targets) => {
                ringGraphics.destroy()
            },
            yoyo: true,
        })
    }

    disband({scale, texture, x, y}) {
        const sprite = Config.scene.add.sprite(x, y, texture)
        sprite.setScale(scale)
        sprite[Config.namespace] = {type: 'effects disband sprite'}

        this.pulse({x, y})

        Config.scene.tweens.add({
            alpha: {from: 1, to: 0},
            delay: 0,
            targets: sprite,
            radius: 50,
            ease: 'Power1',
            duration: 2000,
            onUpdate: (tween, targets) => {
                sprite.angle += 5
                if (sprite.scale > 0) {
                    sprite.scale -= 0.0015
                }
            },
            onComplete: (tween, targets) => {
                sprite.destroy()
            },
        })
    }

    pointAnim({x, y, num, positive, color, imageKey}) {
        if (!Config.scene.add) {
            return
        }
        y = y - 50
        const yDist = 50
        const group = Config.scene.add.group({
            classType: Phaser.GameObjects.Sprite,
        })
        const numCharacters = num.toString().length + 1
        const characterWidth = 13
        x = x - characterWidth * numCharacters
        const symbol = Config.scene.add.text(x, y, `${positive ? '+' : '-'}`, {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '30px',
            fontStyle: 'bold',
            color: `#${color}`,
        })
        symbol.setOrigin(0, 0.5)
        symbol.setResolution(window.devicePixelRatio)
        symbol[Config.namespace] = {type: 'pointAnim symbol'}
        group.add(symbol)

        const image = Config.scene.make.image({
            x: x + (positive ? 18 : 14),
            y,
            key: imageKey,
            scale: {
                x: 0.3,
                y: 0.3,
            },
        })
        image.setOrigin(0, 0.5)
        image[Config.namespace] = {type: 'pointAnim image'}
        group.add(image)

        const text = Config.scene.add.text(x + (positive ? 40 : 36), y, num, {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '30px',
            fontStyle: 'bold',
            color: `#${color}`,
        })
        text.setOrigin(0, 0.5)
        text.setResolution(window.devicePixelRatio)
        text[Config.namespace] = {type: 'pointAnim text'}

        group.add(text)
        group.setDepth(4)
        group[Config.namespace] = {type: 'pointAnim group'}

        Config.scene.tweens.add({
            alpha: {from: 1, to: 0},
            duration: Config.pointAnimDuration,
            ease: 'Sine.easeOut',
            targets: group.getChildren(),
            y: y - yDist,
            onComplete: (tween, targets) => {
                targets.forEach((target) => {
                    target.destroy()
                })
                group.clear(true)
                group.destroy()
            },
        })
    }

    resourceAnim(props) {
        // if (!props.type || (props.type && props.type !== 'resources')) {
        //     audio.resources(props.positive)
        // }
        this.pointAnim({
            ...props,
            color: Config.colorGreen,
            imageKey: 'resourcesGreen',
        })
    }

    scoreAnim(props) {
        this.pointAnim({
            ...props,
            color: 'ffffff',
            imageKey: 'score',
        })
        audio.score()
    }
}
